import { ActivitySwing, Swing } from '@data';
import { queryClient } from '../config/client';
import { getActivitySwingsKey } from '../hooks/useActivitySwings';
import { getSwingKey } from '../hooks/useSwing';

/**
 * Add swing to activity if it doesn't exist
 */
export const addSwingToActivity = (activityId: number, swing: Swing) => {
    const cachedSwings = queryClient.getQueryData<ActivitySwing[]>(getActivitySwingsKey(activityId)) || [];
    const swingIndex = cachedSwings.findIndex((cachedSwing) => cachedSwing.uuid === swing.uuid);

    // Add if not exists
    if (swingIndex !== -1) {
        return;
    }
    queryClient.setQueryData<ActivitySwing[]>(getActivitySwingsKey(activityId), (swings = []): ActivitySwing[] => {
        return [{ ...swing, number: swings.length + 1 }, ...(swings || [])];
    });

    addSwing(swing);
};

export const addSwing = (swing: Swing) => {
    queryClient.setQueryData<Swing>(getSwingKey(swing.uuid), swing);
};

/**
 * Add or update swing in activity
 */
export const upsertSwingToActivity = (activityId: number, swing: Swing) => {
    const cachedSwings = queryClient.getQueryData<ActivitySwing[]>(getActivitySwingsKey(activityId)) || [];
    const swingIndex = cachedSwings.findIndex((cachedSwing) => cachedSwing.uuid === swing.uuid);
    const newSwings =
        swingIndex === -1
            ? [{ ...swing, number: cachedSwings.length + 1 }, ...cachedSwings]
            : [
                  ...cachedSwings.slice(0, swingIndex),
                  { ...swing, number: cachedSwings.length - swingIndex },
                  ...cachedSwings.slice(swingIndex + 1),
              ];

    queryClient.setQueryData<ActivitySwing[]>(getActivitySwingsKey(activityId), newSwings);

    addSwing(swing);
};

export const updateSwingName = (update: Pick<Swing, 'uuid' | 'name' | 'favorite'>) => {
    const key = getSwingKey(update.uuid);

    const cachedSwing = queryClient.getQueryData<Swing | undefined>(key);
    if (!cachedSwing) {
        return;
    }

    queryClient.setQueryData(key, {
        ...cachedSwing,
        ...update,
    });
};
